var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56616 5.10716L7.75372 14.0983L7.74628 14.1718C7.70506 14.5772 7.33753 14.873 6.92537 14.8324C6.51321 14.7919 6.21251 14.4304 6.25372 14.025L6.56607 10.9527C3.81799 11.8292 2 13.3512 2 15.082C2 17.7981 6.47715 20 12 20C17.5228 20 22 17.7981 22 15.082C22 13.3512 20.182 11.8292 17.4339 10.9527L17.7463 14.025C17.7875 14.4304 17.4868 14.7919 17.0746 14.8324C16.6625 14.873 16.2949 14.5772 16.2537 14.1718L16.2462 14.0983L15.4338 5.10716C15.3699 4.47864 14.8322 4 14.19 4H9.80996C9.16777 4 8.63006 4.47864 8.56616 5.10716Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.86f0292d7567b16c1de9505a22d96101.svg";
export { ForwardRef as ReactComponent };